import gql from 'graphql-tag';
import S3Object from './s3_object';

export default gql`
  fragment PublicUserProfile on PublicUserProfile {
    id
    full_name
    job_title
    follower_count
    email_address
    location_title
    location {
      id
      title
      block_message
    }
    department_title
    user_type
    user_status
    reach
    karma
    leaderboard_enabled
    image {
      ...S3Object
    }
  }
  ${S3Object}
`;
